/**
 * Quota Management Constants
 *
 * This file contains validation limits and constraints for quota management.
 * Update these values to change validation rules across the application.
 */

// 32-bit Signed Integer Range
// These limits are imposed by the database column type (INT in SQL)
export const QUOTA_VALIDATION = {
  MIN_VALUE: -2147483648,  // Minimum value for 32-bit signed integer
  MAX_VALUE: 2147483647,   // Maximum value for 32-bit signed integer
};

// Field names that require quota validation
export const QUOTA_FIELDS = {
  QUOTA: 'Quota',
  NQP_GOAL: 'NQP_GOAL',
  NQP_GOAL_LOWERCASE: 'nqpGoal',
};

// Error messages
export const QUOTA_ERROR_MESSAGES = {
  OUT_OF_RANGE: (fieldName) =>
    `${fieldName} must be between ${QUOTA_VALIDATION.MIN_VALUE.toLocaleString()} and ${QUOTA_VALIDATION.MAX_VALUE.toLocaleString()}`,
  MUST_BE_POSITIVE: (fieldName) =>
    `${fieldName} must be a valid positive number`,
  NO_DECIMALS: (fieldName) =>
    `${fieldName} cannot contain decimal values`,
};
